<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <label class="col-form-label">เลือกช่วงวัน</label>
                    &nbsp &nbsp
                    <date-picker
                            v-model="search.start_date"
                            type="date"
                            format="DD/MM/YYYY"
                            lang="en"
                            :not-after="currentDate"
                            placeholder="วันที่เริ่มต้น" >
                    </date-picker>
                    &nbsp
                    <date-picker
                            v-model="search.end_date"
                            type="date"
                            format="DD/MM/YYYY"
                            lang="en"
                            :not-before="search.start_date"
                            :not-after="currentDate"
                            placeholder="วันที่สิ้นสุด" >
                    </date-picker>
                    &nbsp
                    <button @click="searchSale"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon> ค้นหา
                    </button>
                    &nbsp&nbsp
                </form>
            </div>
        </nav>
        <div class="mt-5 row form-group pl-5 pr-5">

            <div class="col-lg-6 pl-0 pr-0 form-group" style="border: 3px solid  #ffc000">
                <div style="background-color: #ffc000;color: white;font-size: 18px">
                    <label class="pl-3 ">จำแนกยอดขายตามประเภทสินค้า</label>
                 </div>
                 <div class="pl-5">
                     <template v-if="pieOverviewProduct.series.length > 0">
                         <apexchart type=pie width="350"
                                    class="size-chart"
                                    @dataPointSelection="dataPointSelectionHandler"
                                    :options="this.pieOverviewProduct.chartOptions"
                                    :series="pieOverviewProduct.series" />
                     </template>
                     <template v-else>
                         <apexchart type=pie width="350"
                                    class="size-chart"
                                    :options="this.pieSetter.chartOptions"
                                    :series="pieSetter.series" />
                     </template>
                 </div>
            </div>
            <div class="col-lg-6  pl-0 pr-0 form-group" style="border: 3px solid  #ffc000">
                 <div style="background-color: #ffc000;color: white;font-size: 18px">
                    <label class="pl-3">จำแนกยอดขายตามตัวแทนจำหน่าย</label>
                 </div>
                 <div class="pl-5">
                     <template v-if="pieOverviewSeller.series.length > 0">
                         <apexchart type=pie
                                    width="430"
                                    class="size-chart"
                                    :options="this.pieOverviewSeller.chartOptions"
                                    :series="pieOverviewSeller.series" />
                     </template>
                     <template v-else>
                         <apexchart type=pie
                                    class="size-chart"
                                    width="430"
                                    :options="this.pieSetter.chartOptions"
                                    :series="pieSetter.series" />
                     </template>

                 </div>
            </div>
        </div>

        <h5 class="pl-2">ใบจองล่าสุด</h5>
        <div class="table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th>วันที่สร้างใบจอง</th>
                    <th>เลขใบจอง</th>
                    <th>รหัสสินค้า</th>
                    <th>ตัวแทนจำหน่าย</th>
                    <th>ยอดขาย</th>

                </tr>
                </thead>
                <tbody>
                <tr v-for="data in OrderList">
                     <td>{{ data.created_at | moment("DD/MM/YYYY") }}</td>
                     <td>{{ data.order_id }}</td>
                     <td>{{ data.customer.customer_id }}</td>
                     <td>{{ data.customer.sale.name }}</td>
                     <td>{{ data.total | currency }}</td>

                </tr>
                </tbody>
            </table>
        </div>
        <b-modal hide-footer hide-header ref="loading">
            <loading @submit="hideLoadingModal" :msg="msg" :status="status_loading"></loading>
        </b-modal>
        <br>
 <!--<pre class="alert alert-danger">{{OrderList}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import DatePicker from 'vue2-datepicker'
    import moment from "moment";
    import Loading from "../Utility/Loading";

    export default {
        name: "dashboard-selling",
        components: {
            Loading,
            DatePicker,
        },
        created(){
            this.$store.dispatch("Dashboard/clearSearch");
            this.getOrderList();
        },
        computed: {
            ...mapState({
                sales: state => {
                    return state.Dashboard.sale_by_seller;
                },
                sales_product: state => {
                    return state.Dashboard.sale_by_product;
                },
                search:state =>{
                    return state.Dashboard.search;
                },
                sales_search:state =>{
                    return state.Dashboard.sale_search;
                },
            })
        },
        data() {
            return {
                msg : "",
                status_loading : 1,
                data:[],
                event_submit : false,
                currentDate: "",
                OrderList : [],
                pieOverviewSeller: {
                    series: [],
                    chartOptions: {
                        labels: [],
                        responsive: [{
                            breakpoint: 480,
                            options: {
                                chart: {
                                    width: 200,
                                },
                                legend: {
                                    position: 'bottom'
                                }

                            }
                        }],
                        theme: {
                            palette: 'palette5'
                        }
                    },
                },
                pieOverviewProduct: {
                    series: [],
                    chartOptions: {
                        labels: [],
                        responsive: [{
                            breakpoint: 480,
                            options: {
                                chart: {
                                    width: 200,
                                },
                                legend: {
                                    position: 'bottom'
                                }
                            }
                        }],
                        theme: {
                            palette: 'palette1'
                        }
                    },
                },
                pieSetter: {
                    series: [100],
                    chartOptions: {
                        labels: ['ไม่มีข้อมูล'],
                        responsive: [{
                            breakpoint: 480,
                            options: {
                                chart: {
                                    width: 200,
                                },
                                legend: {
                                    position: 'bottom'
                                }
                            }
                        }],
                    },
                }

            };
        },
        methods:{
            showLoadingModal(){
              this.$refs.loading.show();
            },
            hideLoadingModal(){
                this.$refs.loading.hide();
            },
            getOrderList(){
                this.$store.dispatch("Order/setOrders").then(res=>{
                    if(res.data.length > 5){
                        this.OrderList = res.data.slice(0,5);
                    }else{
                        this.OrderList = res.data;
                    }
                    this.setPieChart();
                    this.getCurrentDate();
                });
            },
            getCurrentDate(){
                this.currentDate = moment().format("YYYY-MM-DD");
            },
            dataPointSelectionHandler(e, chartContext, config) {
                console.log(config.w.config.labels[config.dataPointIndex]);
            },
            searchSale(){
                this.event_submit = true;
                if(this.search.start_date == null && this.search.end_date){
                    alert('กรุณาใส่วันที่เริ่มต้น')
                }
                else  if(this.search.start_date && this.search.end_date == null){
                    alert('กรุณาใส่วันที่สิ้นสุด')
                }
                else  if(this.search.start_date == null && this.search.end_date == null){
                    this.pieOverviewSeller.chartOptions.labels = [];
                    this.pieOverviewSeller.series = [];

                    this.pieOverviewProduct.chartOptions.labels = [];
                    this.pieOverviewProduct.series = [];
                    this.setPieChart();
                }
                else{
                    this.msg = "กำลังดาวโหลดข้อมูล กรุณารอสักครู่";
                    this.status_loading = 1;
                    this.showLoadingModal();
                    if(this.search.start_date && this.search.end_date){
                        //change date format
                        console.log('format')
                        this.search.start_date = moment(this.search.start_date).format("YYYY-MM-DD");
                        this.search.end_date = moment(this.search.end_date).format("YYYY-MM-DD");
                    }

                    this.$store.dispatch("Dashboard/search",this.search).then(() =>{
                        this.pieOverviewSeller.chartOptions.labels = [];
                        this.pieOverviewSeller.series = [];

                        let sale_name;
                        let total;

                        this.sales_search.sales.forEach(seller=>{
                            if(seller.sale){
                                sale_name = seller.sale.name
                                total = seller.total
                                this.pieOverviewSeller.series.push(total);
                                this.pieOverviewSeller.chartOptions.labels.push(sale_name);
                            }
                            // if(seller.total){
                            //
                            // }
                        })

                        this.pieOverviewProduct.chartOptions.labels = [];
                        this.pieOverviewProduct.series = [];
                        let product_name;
                        let total_product;

                        this.sales_search.sales_product.forEach(seller=>{
                            if(seller.product_name){
                                product_name = seller.product_name
                                total_product = seller.sum
                                this.pieOverviewProduct.series.push(total_product);
                                this.pieOverviewProduct.chartOptions.labels.push(product_name);
                            }
                        })
                        this.hideLoadingModal();
                    }).catch(()=>{
                        this.msg = "ดาวโหลดข้อมูลไม่สำเร็จ";
                        this.status_loading = 3;
                        this.showLoadingModal();
                    })
                }
            },
            setPieChart(){
                console.log(1);
                this.$store.dispatch("Dashboard/getSaleGroupBySeller").then(()=>{
                    let sale_name;
                    let total;
                    this.sales.forEach(seller=>{
                        if(seller.sale){
                            sale_name = seller.sale.name
                            this.pieOverviewSeller.chartOptions.labels.push(sale_name);
                        }
                        if(seller.total){
                            total = seller.total
                            this.pieOverviewSeller.series.push(total);
                        }
                    })
                });
                this.$store.dispatch("Dashboard/getSaleGroupByProduct").then(()=>{
                    let product_name;
                    let total_product;
                    this.sales_product.forEach(seller=>{
                        if(seller.product_name){
                            product_name = seller.product_name
                            this.pieOverviewProduct.chartOptions.labels.push(product_name);
                        }
                        if(seller.total){
                            total_product = seller.sum
                            this.pieOverviewProduct.series.push(total_product);
                        }
                    })
                });
            }
        }
    }

</script>


<style scoped>
    .size-chart{
        max-height: 290px  !important;
        max-width: 380px !important;
    }

    @media only screen and (max-width: 761px){
        .size-chart{
            max-height: 150px;
            max-width: 380px;
        }
    }


</style>
